import { COMMISSION_ITEMS } from "pages/main/cold-storage/components/create-vault/constants";

export const DEPOSIT_MODAL_COMMISSION_ITEMS = COMMISSION_ITEMS;
